import {ActionTypes} from '../types/actionTypes';
import {Action} from '../typescript/actionTypes';


export function updateSetting(name: string, value: any): Action {
    return {type: ActionTypes.UPDATE_SETTING, payload: {[name]: value}};
}
